import {
  collection, addDoc, updateDoc, doc, getDocs, query, where, orderBy, serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase';

// ── Territories (top level) ──────────────────────────────────────────────
export const createTerritory = async ({ name, createdBy }) => {
  const territory = {
    name: name.trim(),
    active: true,
    createdBy: createdBy.id,
    createdByName: createdBy.name,
    createdAt: serverTimestamp()
  };
  const docRef = await addDoc(collection(db, 'territories'), territory);
  return { id: docRef.id, ...territory };
};

export const listTerritories = async () => {
  const snap = await getDocs(query(collection(db, 'territories'), orderBy('name')));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ── Divisions (belong to a Territory) ────────────────────────────────────
export const createDivision = async ({ name, territory, createdBy }) => {
  const division = {
    name: name.trim(),
    territoryId: territory.id,
    territoryName: territory.name,
    active: true,
    createdBy: createdBy.id,
    createdByName: createdBy.name,
    createdAt: serverTimestamp()
  };
  const docRef = await addDoc(collection(db, 'divisions'), division);
  return { id: docRef.id, ...division };
};

export const listDivisions = async () => {
  const snap = await getDocs(query(collection(db, 'divisions'), orderBy('name')));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ── Areas (belong to a Division, which belongs to a Territory) ──────────
// Areas are the level outlets will eventually attach to — deliberately
// carrying territoryId/territoryName too (denormalized) so a report can
// filter straight by territory without walking the chain every time.
export const createArea = async ({ name, division, createdBy }) => {
  const area = {
    name: name.trim(),
    divisionId: division.id,
    divisionName: division.name,
    territoryId: division.territoryId,
    territoryName: division.territoryName,
    active: true,
    createdBy: createdBy.id,
    createdByName: createdBy.name,
    createdAt: serverTimestamp()
  };
  const docRef = await addDoc(collection(db, 'areas'), area);
  return { id: docRef.id, ...area };
};

export const listAreas = async () => {
  const snap = await getDocs(query(collection(db, 'areas'), orderBy('name')));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const listAreasForDivision = async (divisionId) => {
  const q = query(collection(db, 'areas'), where('divisionId', '==', divisionId), orderBy('name'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// ── Deactivate (soft-delete, matches the pattern used elsewhere) ────────
export const deactivateTerritory = (id) => updateDoc(doc(db, 'territories', id), { active: false, updatedAt: serverTimestamp() });
export const deactivateDivision  = (id) => updateDoc(doc(db, 'divisions', id),  { active: false, updatedAt: serverTimestamp() });
export const deactivateArea      = (id) => updateDoc(doc(db, 'areas', id),      { active: false, updatedAt: serverTimestamp() });
